module.exports = __webpack_public_path__ + "img/phone2.6930a6ec.svg";